import { render, staticRenderFns } from "./Geothermal.vue?vue&type=template&id=0544042a&scoped=true"
import script from "./Geothermal.vue?vue&type=script&lang=js"
export * from "./Geothermal.vue?vue&type=script&lang=js"
import style0 from "./Geothermal.vue?vue&type=style&index=0&id=0544042a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0544042a",
  null
  
)

export default component.exports